import { setTaskData } from "@/redux/slices";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { transformTaskData } from "../consts";
import { RootState } from "@/redux/store";
import { useParams } from "react-router-dom";
import { routes } from "@/routes/utils";
import { useGetPlanById, useGetTaskList } from "@/services";
import { planStatus } from "@/lib/utils";

const useNormalView = () => {
  const dispatch = useDispatch();
  const {action, planId, planAction} = useParams();
  const isView = action == routes.view || planAction == routes.view;
  const {taskData, projectData} = useSelector((state: RootState) => state.currentData);

  const {data: planData, isLoading: isPlanLoading} = useGetPlanById({
    planId: planId as string,
    projectId: projectData?.projectId,
    queryParams: {
      enabled: !!(planId && projectData?.projectId)
    }
  })

  const isPlanDraft = useMemo(() => planData?.data?.status == planStatus.draft.value, [planData]);

  const {data: taskList, isLoading: isTaskLoading} = useGetTaskList({
    planId: planId as string,
    projectId: projectData?.projectId,
    queryParams: {
      enabled: !!(planId && projectData?.projectId && isPlanDraft)
    }
  });
  
  const onAddNewTask = () => {
    dispatch(setTaskData(null));
  }

  const onRowClick = (row: any) => {
    if (row.depth == 2) {
      dispatch(setTaskData({...row.original, id: row.id}));
    }
  }

  const taskListData = useMemo(() => {
    if (taskList?.data) {
      return transformTaskData(taskList?.data)
    }
    return [];
  }, [taskList]);

  const taskColumns = useMemo(() => {
    return [
      {
        accessorKey: "name",
        header: "Name",
        accessorFn: (row: any) => String(row?.name || ''),
      },
      {
        accessorKey: "duration",
        header: "Duration",
        accessorFn: (row: any) => String(row?.duration || ''),
      },
      {
        accessorKey: "start",
        header: "Start",
        accessorFn: (row: any) => String(row?.start || ''),
      },
      {
        accessorKey: "end",
        header: "End",
        accessorFn: (row: any) => String(row?.end || ''),
      },
    ];
  }, []);
  
  const isTaskExist = useMemo(() => {
    return taskList?.data?.length;
  }, [taskList]);

  return {
    isPlanLoading,
    taskColumns,
    isTaskLoading,
    taskListData,
    onRowClick,
    taskData,
    isTaskExist,
    taskList: taskList?.data || [],
    isView,
    onAddNewTask,
  }
}

export default useNormalView;